/* eslint-disable no-param-reassign */
import produce from 'immer';
import { GET_SCAN_PROMPTS, SAVE_SCAN_PROMPT } from 'src/redux/actions/scanPromptActions';

const initialState = {
  // [{ provider, prompt, version, updatedByName, updatedAt }], null until loaded
  prompts: null,
  maxLength: 50000,
};

const scanPromptReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SCAN_PROMPTS: {
      const { prompts, maxLength } = action.payload;
      return produce(state, (draft) => {
        draft.prompts = prompts;
        if (maxLength) draft.maxLength = maxLength;
      });
    }

    case SAVE_SCAN_PROMPT: {
      const saved = action.payload;
      return produce(state, (draft) => {
        const list = draft.prompts || [];
        const index = list.findIndex((p) => p.provider === saved.provider);
        if (index === -1) list.push(saved);
        else list[index] = saved;
        draft.prompts = list;
      });
    }

    default: {
      return state;
    }
  }
};

export default scanPromptReducer;
